import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export function getSupporterCode() {
  return localStorage.getItem("technow_supporter_code");
}

export function setSupporterCode(code) {
  localStorage.setItem("technow_supporter_code", code);
  window.dispatchEvent(new Event("technow:unlock"));
}

export function supporterHeaders() {
  const code = getSupporterCode();
  return code ? { headers: { "X-Supporter-Code": code } } : {};
}

export function apiError(e, fallback = "Something went wrong") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
